"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../");
var App_1 = require("../../App");
/**
 * A customizable button component that can be used for various purposes.
 * Supports regular buttons and buttons that interact with Firebase.
 *
 * @example_without_firebase
 * ```tsx
 * <Button
 * onClick={() => console.log('Button clicked!')}
 * >Click me!</Button>
 * ```
 *
 * @example_with_firebase
 *
 * ```tsx
 * <Button
 *     firebase
 *     data={{ name: 'Eloise' }}
 *     path="plans/id" // user is already handled
 *     next={afterPost}// function to call on sucessful post
 * >  Submit </Button>
 * ```
 */
var Button = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 0 : _b, _c = _a.rounded, rounded = _c === void 0 ? true : _c, className = _a.className, children = _a.children, _d = _a.firebase, firebase = _d === void 0 ? false : _d, purpose = _a.purpose, props = __rest(_a, ["color", "rounded", "className", "children", "firebase", "purpose"]);
    var _e = (0, App_1.useEloise)(), theme = _e.theme, logic = _e.logic; // Accesses the theme and logic from the app context using the useEloise hook
    // Handling firebase case
    if (firebase) {
        var _f = props, data_1 = _f.data, path_1 = _f.path, next_1 = _f.next;
        // Perform any required action with data and path
        var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
            var post;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, logic.fb.docs.setUserDoc(path_1, data_1)];
                    case 1:
                        post = _a.sent();
                        if (post) {
                            next_1(); // Runs the next function if post is successful
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Renders the ButtonWrapper component with the appropriate props
        return (react_1.default.createElement(ButtonWrapper, { logic: logic, backgroundColor: typeof color === "number"
                ? logic.color.convertToHSLA(theme.colors[color])
                : color, theme: theme, rounded: rounded, className: className, onClick: submit, "aria-label": props["ariaLabel"], role: props.role, tabIndex: props.tabIndex }, children));
    }
    var onClick = props.onClick;
    // Renders the ButtonWrapper component with the appropriate props
    return (react_1.default.createElement(__1.EloiseWidget, { eloiseIntel: { purpose: purpose } },
        react_1.default.createElement(ButtonWrapper, { logic: logic, backgroundColor: color
                ? typeof color === "number"
                    ? logic.color.convertToHSLA(theme.colors[color])
                    : color
                : logic.color.convertToHSLA(theme.colors[0]), theme: theme, rounded: rounded, className: className, onClick: onClick, "aria-label": props["ariaLabel"], role: props.role, tabIndex: props.tabIndex, style: props.style }, children)));
};
exports.Button = Button;
var ButtonWrapper = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", "; // Sets the background color to the passed color or default primary color\n  color: white;\n  border-radius: ", "; // Sets the border radius to the default radius in the theme or 0 if not rounded\n  border: ", "; // Sets the border style to the default border style in the theme\n  padding: 0.75rem 1.5rem; // Sets the padding of the button\n  transition: background-color 0.2s, transform 0.2s; // Adds a transition effect to the background color and transform\n\n  // Hover state\n  &:hover {\n    background-color: ", "; // Lightens the background color of the button\n    transform: translateY(-3px); // Moves the button up by 3px\n    cursor: pointer; // Sets the cursor to a pointer\n  }\n\n  // Active state\n  &:active {\n    background-color: ", "; // Darkens the background color of the button\n    transform: translateY(0); // Resets the button to its original position\n  }\n"], ["\n  width: 100%;\n  background-color: ", "; // Sets the background color to the passed color or default primary color\n  color: white;\n  border-radius: ", "; // Sets the border radius to the default radius in the theme or 0 if not rounded\n  border: ", "; // Sets the border style to the default border style in the theme\n  padding: 0.75rem 1.5rem; // Sets the padding of the button\n  transition: background-color 0.2s, transform 0.2s; // Adds a transition effect to the background color and transform\n\n  // Hover state\n  &:hover {\n    background-color: ", "; // Lightens the background color of the button\n    transform: translateY(-3px); // Moves the button up by 3px\n    cursor: pointer; // Sets the cursor to a pointer\n  }\n\n  // Active state\n  &:active {\n    background-color: ", "; // Darkens the background color of the button\n    transform: translateY(0); // Resets the button to its original position\n  }\n"])), function (props) {
    return props.backgroundColor;
}, function (props) {
    return props.rounded
        ? "3px"
        : "0";
}, function (props) {
    return props.theme
        .border;
}, function (props) {
    return props.logic.color.lighten(props.backgroundColor);
}, function (props) {
    return props.logic.color.darken(props.backgroundColor);
});
var templateObject_1;
